import { PlatformLocation } from '@angular/common';

const domainsToDomainKeys = {
    // tmg
    'group-buy.metro.tokyo.lg.jp': 'tmg',
    'app-jp-tmg-demo.ichoosr.com': 'tmg',
    // niigata
    'group-buy.pref.niigata.lg.jp': 'niigata',
    'app-jp-niigata-demo.ichoosr.com': 'niigata',
};

const backOfficeParam = 'backofficeLink';

export function getIdentityUri(
    environment: {
        backofficeIdentityUri: string;
        identityUri: string;
        tokyoIdentityUri: string;
        niigataIdentityUri: string;
    },
    platformLocation: PlatformLocation,
) {
    if (!platformLocation) {
        return environment.identityUri;
    }

    if (new URLSearchParams(platformLocation.search).has(backOfficeParam)) {
        return environment.backofficeIdentityUri;
    }

    const domainKey = findDomainKey(platformLocation);

    if (domainKey === 'tmg' && environment.tokyoIdentityUri) {
        return environment.tokyoIdentityUri;
    }

    if (domainKey === 'niigata' && environment.niigataIdentityUri) {
        return environment.niigataIdentityUri;
    }

    return environment.identityUri;
}

export function findDomainKey(platformLocation: PlatformLocation): string {
    const domain = Object.keys(domainsToDomainKeys).find((domain) =>
        platformLocation?.href?.includes(domain),
    );
    return domainsToDomainKeys[domain] || 'default';
}
